import styles from './mega-button.module.css'
import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import { cc } from 'go2sim-types'

interface Props {
  onClick?: () => void
  enabled?: boolean
  children?: ReactNode | ReactNode[]
  display?: 'inline' | 'inline-block' | 'block'
  type?: 'gradient' | 'outline'
  size?: 'standard' | 'small'
  style?: CSSProperties
  animate?: boolean
}

const Button = (props:Props) => {

  const buttonRef = useRef(null)
  const canvasRef = useRef(null)
  const [size, setSize] = useState([0, 0])
  const [mousePos, setMousePos] = useState([0,0])
  const [isHovered, setIsHovered] = useState(true)

  const mousePosRef = useRef(mousePos)
  const isHoveredRef = useRef(isHovered)

  useEffect(() => {
    if(props.animate === true) { requestAnimationFrame(animate) }
  }, [])

  useEffect(() => {
    mousePosRef.current = mousePos
  }, [mousePos])

  useEffect(() => {
    isHoveredRef.current = isHovered
  }, [isHovered])

  useEffect(() => {
    setSize([
      buttonRef.current.clientHeight,
      buttonRef.current.clientWidth,
    ])
  }, [buttonRef])

  useEffect(() => {
    if(canvasRef.current) {
      canvasRef.current.removeEventListener('mousemove', onMouseMove)
      canvasRef.current.addEventListener('mousemove', onMouseMove)
      canvasRef.current.removeEventListener('mouseenter', onMouseEnter)
      canvasRef.current.addEventListener('mouseenter', onMouseEnter)
      canvasRef.current.removeEventListener('mouseleave', onMouseLeave)
      canvasRef.current.addEventListener('mouseleave', onMouseLeave)
    }
  }, [canvasRef])

  const onMouseEnter = () => { setIsHovered(true) }
  const onMouseLeave = () => { setIsHovered(false) }
  const onMouseMove = (evt:MouseEvent) => { setMousePos([evt.offsetX, evt.offsetY]) }

  const animate = () => {

    const canvas = canvasRef.current as HTMLCanvasElement
    const ctx = canvas.getContext("2d")

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    if(isHoveredRef.current === true) {

      var grd = ctx.createRadialGradient(mousePosRef.current[0], mousePosRef.current[1], 5, mousePosRef.current[0] + 1, mousePosRef.current[1] + 1, canvas.width)

      grd.addColorStop(0, "#B2005D88")
      grd.addColorStop(0.3, "#D50D4388")
      grd.addColorStop(0.6, "#F6292588")
      grd.addColorStop(1, "#FFAE0088")

      ctx.fillStyle = grd
      ctx.beginPath();
      ctx.roundRect(0, 0, canvas.width + 1, canvas.height + 1, canvas.height / 2);
      ctx.fill()
      ctx.closePath()

      ctx.beginPath()
      ctx.arc(mousePosRef.current[0], mousePosRef.current[1], 10, 0, 2 * Math.PI, true)
      ctx.fillStyle = "green"
      ctx.fill()
      ctx.closePath()

    }
    requestAnimationFrame(animate)
  }

  let style:CSSProperties = props.style ? { ...props.style } : {}
  if(props.display) style.display = props.display

  return (
    <div
      ref={buttonRef}
      style={style}
      className={cc(
        styles['button'], 
        props.type ? styles[props.type] : styles['gradient'],
        props.size || props.size != 'standard' ? styles[props.size] : null,
        props.enabled === undefined 
          ? null
          : props.enabled === true
            ? null
            : styles['disabled']
      )}
      onClick={() => {
        if(props.enabled === undefined) {
          props.onClick()
        } else {
          if(props.enabled === true) { props.onClick() }
        }
      }}>
        <canvas ref={canvasRef} width={size[1]} height={size[0]} className={styles['canvas']}/>
        {props.children}
    </div>
  )
}

export default Button